<script lang="ts">
  import Main from "components/Main.svelte";
  import { pageState } from "state/page";
  import DetailBottomActionBar from "components/BottomActionBars/Detail.svelte";
  import EditBottomActionBar from "components/BottomActionBars/Edit.svelte";
  import SearchBottomActionBar from "components/BottomActionBars/Search.svelte";
  import { getCloseCallback } from "config";
  import { listenForMessages, stopListeningForMessages } from "services/pluginMessages";
  import { onMount } from "svelte";
  import Providers from "../Providers/Providers.svelte";
  import GlassPane from "./GlassPane.svelte";

  const onKeyDown = (event: KeyboardEvent) => {
    const targetEl = event.target as HTMLElement;
    if (event.key === "Escape") {
      if (targetEl.nodeName === "INPUT" && (targetEl as HTMLInputElement).type === "text") {
        targetEl.blur();
      } else {
        const cancelCallback = getCloseCallback();
        if (cancelCallback) {
          cancelCallback();
        }
      }
    }
  };

  onMount(() => {
    window.addEventListener("keydown", onKeyDown);
    listenForMessages();
    return () => {
      window.removeEventListener("keydown", onKeyDown);
      stopListeningForMessages();
    };
  });
</script>

<div class="org-root org-theme-dark" id="bildebanken-root">
  <Providers>
    <Main />
    {#if $pageState.type === "DETAIL"}
      <DetailBottomActionBar state={$pageState} />
    {:else if $pageState.type === "UPLOAD" || $pageState.type === "EDIT"}
      <EditBottomActionBar />
    {:else if $pageState.type === "SEARCH"}
      <SearchBottomActionBar state={$pageState} />
    {/if}
    <GlassPane />
  </Providers>
</div>

<style>
  div.org-root {
    font:
      0.875rem/1.7 Roboto,
      sans-serif;
    -moz-osx-font-smoothing: grayscale;
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
    position: relative;
    isolation: isolate;
    overflow: hidden;
  }
</style>
